import request from '@/utils/request';

export function wechatShare() {
  const ajaxurl = window.location.href.split('#')[0];
  return request({
    url: 'https://fc.gz-cmc.com/share/getWechatShareInfo',
    params: {
      url: ajaxurl,
    },
    method: 'get',
  });
}

// 用于避免需要使用 export default，当增加一个export 方法后可以删除
export function test() {}
